module.exports = __webpack_public_path__ + "static/media/i33.a5a56082.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i33.svg
// module id = 355
// module chunks = 8